
function ScorecardController($state, $timeout, ScorecardService, scorecard,
                             program, config, numberFilter, permissions) {

    var vm = this;

    this.canEdit = permissions.editScorecard;
    this.config = config.model;
    this.scorecard = scorecard;
    this.sections = getSections(config, $state.current.data.is_ybusa);

    this.getOptionValue = getOptionValue;
    this.showQuestion = showQuestion;
    this.saveScorecard = saveScorecard;
    this.selectOptions = getSelectOptions(this.sections);

    this.financeQuestions = ['total_liabilities', 'total_assets', 'cash_on_hand',
                             'operating_expenses', 'line_of_credit',
                             'credit_in_use']


    this.dials = [{
        label: 'Site Score',
        name: 'practices',
        data: [0, 1],
        colors: ['#DDD', '#DDD'],
    }, {
        label: 'Internal Score',
        name: 'scorecard',
        data: [0, 1],
        colors: ['#DDD', '#DDD'],
    }, {
        label: 'Total Score',
        name: 'overall',
        data: [0, 1],
        colors: ['#DDD','#DDD'],
    }]

    $timeout(updateDials, 500);

    function updateDials() {
        if (!$state.current.data.is_ybusa) return;
        angular.forEach(vm.dials, function(dial) {
            dial.data = [scorecard.score[dial.name].points,
                         scorecard.score[dial.name].missing];
            dial.colors = ['#064B8D', '#DDD'];

            dial.text = numberFilter(scorecard.score[dial.name].percent || 0, 0) + "%";
            dial.details =
                scorecard.score[dial.name].points + " of " +
                scorecard.score[dial.name].available + " points"
        });
    }

    function getOptionValue(option) {
        return option.id;
    }

    function showQuestion(dybForm, question) {
        return !question.conditional_on || (
            dybForm.formData[question.conditional_on] &&
            dybForm.formData[question.conditional_on] === question.conditional_value);
    }

    function saveScorecard(data) {
        return ScorecardService.patchScorecard(scorecard, data)
            .then(updateDials);
    }

    function dialDataGetter(name) {
        return function() {
            return [scorecard.score[name].points, scorecard.score[name].missing];
        }
    }

    function dialTextGetter(name, percent) {
        return function() {
            if (percent) {
                return numberFilter(scorecard.score[name].percent, 0) + '%';
            }
            return scorecard.score[name].points;
        }
    }

    function getSelectOptions(sections) {
        return sections.reduce(function(cache, section) {
            section.questions.forEach(function(question) {
                if (question.question_type === 'select') {
                    cache[question.name] = question.options.map(function(opt) {
                        return [opt.id, opt.text];
                    });
                }
            })
            return cache;
        }, {})
    }
}

function getSections(config, is_ybusa) {
    return config.sections.filter(function(item) {
        return  item.is_ybusa === is_ybusa;
    })
}

module.controller('ScorecardController', ScorecardController)
